// extracted by mini-css-extract-plugin
export default {"form":"Ed","inline":"Fd","inputWrapper":"Gd","input":"Hd","withoutLabel":"Id","error":"Jd","label":"Kd"};